import React, {useEffect, useMemo} from "react";
import {
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import {BrowserRouter} from "~/apps/core/BrowserRouter";
import {IndexPage} from "./components/IndexPage";
import {AccessRequired} from "~/apps/core/ui/AccessRequired";
import {DetailPage} from "./components/DetailPage";
import {CreatePage} from "~/apps/packages/passes/components/CreatePage";
import {useApolloClient} from "@apollo/client";
import {ServiceInterview} from "~/customers-experience/ServiceInterview";


export const APP_NAME = "passes";
export const APP_VERSION = "1.0.0"


const PassesApp = () => {
    const client = useApolloClient();

    // Invalidate apollo cache when leave service
    useEffect(() => () => {
        client.cache.evict({id: "ROOT_QUERY", fieldName: "admissions"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "admissionEmployers"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "admissionCars"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "admissionCompany"});
    }, []);

    return (
        <AccessRequired title="Заявки на пропуск">
            <BrowserRouter basename="/apps/passes">
                <ServiceInterview serviceID={APP_NAME} serviceVersion={APP_VERSION}>
                    <Switch>
                        <Route path="/" exact={true}>
                            <IndexPage/>
                        </Route>
                        <Route path="/new">
                            <CreatePage/>
                        </Route>
                        <Route path="/:id" exact={true}>
                            <DetailPage/>
                        </Route>
                        <Route path="*">
                            <Redirect to="/"/>
                        </Route>
                    </Switch>
                </ServiceInterview>
            </BrowserRouter>
        </AccessRequired>
    );
}


export default PassesApp;